import { Offcanvas } from 'bootstrap';

const menu = document.getElementById('mobile-menu');

if (menu) {

  const bodyEl = document.querySelector('body');
  const menuNav = menu.querySelector('#mobile-menu-nav') || null;
  const menuSubnavLinks = menuNav.querySelectorAll('[data-toggle="mobileSubnav"]');
  const menuBackLinks = menu.querySelectorAll('[data-toggle="resetMobileMenu"]');
  const menuSubnavs = menu.querySelectorAll('.mobile-menu-subnav');

  function showSubnav(target) {
    menuNav.classList.remove('show');

    target.removeAttribute('aria-hidden');
    target.setAttribute('aria-role', 'dialog');
    target.setAttribute('aria-modal', 'true');

    target.style.visibility = "visible";
    target.classList.add('show');
  }

  function resetMenu() {
    menuNav.style.visibility = null;
    menuNav.removeAttribute('aria-hidden');
    menuNav.classList.add('show');

    menuSubnavs.forEach((el) => {
      el.classList.remove('show');
      el.removeAttribute('aria-role');
      el.removeAttribute('aria-modal');
    });
  }

  menu.addEventListener('hidden.bs.offcanvas', function () {
    resetMenu();
  });

  // Listen for #mobile-menu-nav (top-level nav) to finish a transition
  menuNav.addEventListener('transitionend', function () {
    // If the #mobile-menu-nav was show, focus it and hide all the subnavs
    if (menuNav.classList.contains('show')) {
      menuNav.focus();

      menuSubnavs.forEach((el) => {
        el.style.visibility = "hidden";
        el.setAttribute('aria-hidden', 'true');
      })
    } else {
      // else hide the #mobile-menu-nav
      menuNav.style.visibility = "hidden";
      menuNav.setAttribute('aria-hidden', 'true');
    }
  });

  // After a subnav transition ends, focus it if it's visible (has .show class)
  menuSubnavs.forEach((nav) => {
    nav.addEventListener('transitionend', function () {
      if (this.classList.contains('show')) {
        this.focus();
      }
    });
  });

  menuSubnavLinks.forEach(function (el) {
    let targetEl = menu.querySelector(el.getAttribute('data-target'));
    el.addEventListener('click', () => showSubnav(targetEl));
  });

  menuBackLinks.forEach(function (el) {
    el.addEventListener('click', () => resetMenu());
  });
}
